import React from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

interface Props {
  to: string;
  label: string;
}

const BackToButton: React.FC<Props> = ({ to, label }) => {
  return (
    <Button
      component={Link}
      to={to}
      variant="text"
      startIcon={<ArrowBackIcon color="primary" />}
    >
      {label}
    </Button>
  );
};

export default BackToButton;
